export const countriesWithFlags = [
  "AF",
  "AS",
  "AU",
  "AT",
  "AX",
  "AW",
  "BE",
  "BN",
  "BQ",
  "BR",
  "BV",
  "CA",
  "CH",
  "CL",
  "DK",
  "EC",
  "ES",
  "FI",
  "FR",
  "DE",
  "MP",
  "NO",
  "GF",
  "GP",
  "GU",
  "IE",
  "IN",
  "IQ",
  "IR",
  "IT",
  "LA",
  "LU",
  "IS",
  "JP",
  "KH",
  "KR",
  "LI",
  "LT",
  "MH",
  "FM",
  "MT",
  "MM",
  "MX",
  "MY",
  "NL",
  "PR",
  "PT",
  "PW",
  "SA",
  "SE",
  "TH",
  "TM",
  "TR",
  "TW",
  "GB",
  "US",
  "UZ",
  "VI",
  "VN",
  "AL",
  "BA",
  "BG",
  "HR",
  "CZ",
  "EE",
  "HU",
  "XK",
  "LV",
  "ME",
  "MK",
  "PL",
  "RO",
  "RS",
  "SK",
  "SI",
  "UA",
  "CY",
  "PK",
  "GR",
  "AD",
  "AE",
  "AG",
  "AI",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AZ",
  "BB",
  "BD",
  "BF",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BO",
  "BS",
  "BT",
  "BW",
  "BY",
  "BZ",
  "CC",
  "CD",
  "CF",
  "CG",
  "CI",
  "CK",
  "CM",
  "CN",
  "CO",
  "CR",
  "CV",
  "CU",
  "CW",
  "CX",
  "DJ",
  "DM",
  "DO",
  "DZ",
  "EG",
  "EH",
  "ER",
  "ET",
  "FJ",
  "FK",
  "FO",
  "GA",
  "GD",
  "GE",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GQ",
  "GT",
  "GW",
  "GY",
  "HK",
  "HN",
  "HT",
  "IL",
  "IM",
  "JE",
  "JM",
  "JO",
  "KE",
  "KG",
  "KI",
  "KM",
  "KN",
  "KW",
  "KY",
  "KZ",
  "LB",
  "LC",
  "LK",
  "LR",
  "LS",
  "LY",
  "MA",
  "MC",
  "MD",
  "MF",
  "MG",
  "ML",
  "MN",
  "NA",
  "NC",
  "NE",
  "NI",
  "NP",
  "NR",
  "NZ",
  "OM",
  "PA",
  "PF",
  "PG",
  "PH",
  "PN",
  "PS",
  "PY",
  "QA",
  "RU",
  "RW",
  "SB",
  "SC",
  "SD",
  "SG",
  "SL",
  "SM",
  "SN",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TJ",
  "TL",
  "TN",
  "TT",
  "TZ",
  "UG",
  "UY",
  "VA",
  "VC",
  "VE",
  "VG",
  "VU",
  "WF",
  "WS",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
  "BM",
  "ID",
  "MU",
  "PE",
  "NG",
  "MZ",
  "MW",
  "MR",
  "SH",
  "SO",
  "RE",
  "TO",
  "GS",
  "HM",
  "IO",
  "KP",
  "MO",
  "MQ",
  "MS",
  "MV",
  "NF",
  "NU",
  "PM",
  "SJ",
  "TK",
  "TV",
  "UM",
];

